module.exports = __webpack_public_path__ + "static/media/2.03df0214.svg";